import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ArrowRightCircle = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M12 11V8l4 4-4 4v-3H8v-2h4Zm0-9a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
    />
  </svg>
));
